import { useEffect, useRef } from 'react';

/**
 * Returns the previous value of `value`, initialized with `initialValue`.
 *
 * @param value The value whose history you want to keep
 * @param initialValue Initial value for the "previous" value
 * @returns The previous value
 */
export function usePrevious<T>(value: T, initialValue?: T): T | null {
  const ref = useRef<T | null>(initialValue ?? null);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
